import { type ReactNode } from 'react';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { OkrPage } from '../../features/performance/components/okr-page';
import { OkrSearch } from '../../features/performance/okr-search';

export const Route = createFileRoute('/_app/okr/$userId')({
  validateSearch: OkrSearch,
  component: OkrForUser,
});

/** OKR của **một người dưới quyền** — APM-OKR-c. Thân trang ở `OkrPage`. */
function OkrForUser(): ReactNode {
  const { userId } = Route.useParams();
  const navigate = useNavigate({ from: Route.fullPath });
  const search = Route.useSearch();

  return (
    <OkrPage
      userId={userId}
      // Đích của deep-link từ bảng hiệu suất nhóm, nên "về" có chỗ để về.
      backToPerformance
      tab={search.tab ?? 'overview'}
      offset={search.offset ?? 0}
      onTabChange={(tab) =>
        void navigate({ search: { tab: tab === 'overview' ? undefined : tab } })
      }
      onOffsetChange={(offset) =>
        void navigate({ search: { ...search, offset: offset === 0 ? undefined : offset } })
      }
      onOpenPeriod={(tab, offset) =>
        void navigate({
          search: {
            ...search,
            tab: tab === 'overview' ? undefined : tab,
            offset: offset === 0 ? undefined : offset,
          },
        })
      }
    />
  );
}
